<template>
  <div class="container p-4">
    <div class="card">
      <div class="card-title pb-0 pl-4 pt-4">
        <h6>Números detalhados por status de acompanhamento</h6>
      </div>
      <paper
        v-for="line in paperData.lines"
        :title="line.title"
        :ranges="line.range"
        :key="line.title"
      />
    </div>
  </div>
</template>

<script>
import Paper from "./Components/Paper";
import { reportsComputed, reportsMethods } from "../../state/helpers";

export default {
  components: {
    Paper
  },
  data() {
    return {
      paperData: {}
    };
  },
  mounted() {
    this.getStatuses();
    this.getPaperData();
  },
  methods: {
    ...reportsMethods,
    getRanges(item) {
      const keys = Object.keys(item);
      const ranges = [];
      keys.map(key => {
        if (key !== "status")
          ranges.push({
            label: key,
            amount: item[key]
          });
      });
      return ranges;
    },
    getPaperData() {
      this.paperData = {
        lines: this.statuses.map(item => {
          return {
            title: item.status,
            range: this.getRanges(item)
          };
        })
      };
    }
  },
  computed: {
    ...reportsComputed
  }
};
</script>